export default __webpack_public_path__ + "cb5fc4f6ec7ada72e986f6e7dde365bf.png";